import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newTruck() {
    let trucksDetails = {
      transporter_id: $(".transporter_id").val(),
      truck_no: $(".truck_no").val(),
      trailer_no: $(".trailer_no").val(),
      truck_license_Date: $(".truck_license_Date").val(),
      truck_expiry_date: $(".truck_expiry_date").val(),
      trailer_license_Date: $(".trailer_license_Date").val(),
      trailer_expiry_date: $(".trailer_expiry_date").val()
    };
    $(".creatingTruck").hide();
    $(".creatingTruckLoader").show();
    baseurl.post(rt.newTruck, trucksDetails).then(res => {
      $(".creatingTruck").show();
      $(".creatingTruckLoader").hide();
      $(".form-control").val("");

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.truckCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //truck data exits
        ers.TruckExists();
      } else if (res.data.code === 404) {
        //error on creating truck data
        ers.errorCreatingTruck();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadTrucks({ commit }) {
    baseurl.get(rt.loadTrucks).then(res => {
      $(".trucksLoader").hide();

      //checking response codes

      if (res.data.code === 200) {
        //success codes
        commit("STORE_TRUCKS", res.data.trucks);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingTruck();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_TRUCKS", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadTruck({ commit }) {
    baseurl.get(rt.loadTruck).then(res => {
      $(".trucksLoader").hide();

      //checking response codes

      if (res.data.code === 200) {
        //success codes
        commit("STORE_TRUCK", res.data.truck);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingTruck();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_TRUCK", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadAllocations({ commit }) {
    baseurl.get(rt.loadTruckallocation).then(res => {
      $(".trucksLoader").hide();

      //checking response codes

      if (res.data.code === 200) {
        //success codes
        commit("STORE_TRUCK_ALLOCATIONS", res.data.truckallocations);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingTruck();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_TRUCK_ALLOCATIONS", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  viewTruck({ commit }, truckId) {
    commit("STORE_TRUCK_UPDATE", truckId);
    router.push("/updatetruck");
  },
  viewTrucks({ commit }, truckId) {
    commit("STORE_TRUCK_UPDATE", truckId);
  },

 
  truckUpdate({ commit }) {
    let trucksDetails = {
      id: $(".id").val(),
      transporter_id: $(".transporter_id").val(),
      truck_no: $(".truck_no").val(),
      trailer_no: $(".trailer_no").val(),
      truck_license_Date: $(".truck_license_Date").val(),
      truck_expiry_date: $(".truck_expiry_date").val(),
      trailer_license_Date: $(".trailer_license_Date").val(),
      trailer_expiry_date: $(".trailer_expiry_date").val()
    };

    $(".updatingTruck").hide();
    $(".updatingTruckLoader").show();
    baseurl.post(rt.updateTruck, trucksDetails).then(res => {
      $(".updatingTruck").show();
      $(".updatingTruckLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code and mutations
        suc.truckUpdateSuccess();
        commit("STORE_TRUCKS", res.data.trucks);
        setTimeout(() => {
          router.push("/managetrucks");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating data
        ers.errorUpdatingTruck();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/trucks/actions.js